<div class="delivery-details container"
  [appLoadingAnimation]="isUserDataLoading || isCartEmpty || loadingCartDataInProgress">
  @if (cartDataLoaded && cartItemsDataLoaded && !loadingCartDataInProgress) {
    <app-spare-part-order-details-section
      [ngClass]="{'hidden': isOnContactDetailsSection}"
      [cartId]="cartId"
      [cartAttributes]="cartAttributes"
      [cartItemsWithDetails]="cartItemsWithDetails"
      [cartRules]="cartRules"
      [systemDetails]="systemDetails"
      [loggedUserRoles]="userData.companyRoles"
      [userLoggedData]="userData"
      [isSaturdayShipment]="isSaturdayShipment"
      [isPriceDisputingActive]="isPriceDisputingActive"
      (formSubmitted)="proceedToContactDetails($event)"
      (addressChangedEmitter)="addressChanged = $event">
    </app-spare-part-order-details-section>
  }
  @if (cartDataLoaded && cartItemsDataLoaded && !loadingCartDataInProgress) {
    <app-spare-part-contact-details-section
      [ngClass]="{'hidden': !isOnContactDetailsSection}"
      [cartId]="cartId"
      [cartAttributes]="cartAttributes"
      [cartItemsWithDetails]="cartItemsWithDetails"
      [cartRules]="cartRules"
      [creatingOrderInProgress]="creatingOrderInProgress"
      [isOnContactDetailsSection]="isOnContactDetailsSection"
      [addressChanged]="addressChanged"
      [isSaturdayShipment]="isSaturdayShipment"
      [isPriceDisputingActive]="isPriceDisputingActive"
      [shipToAddress]="orderDetailsData?.shipToAddress"
      [hasSapDiscountsValue]="hasSapDiscounts()"
      (backToOrderDetails)="proceedToOrderDetails()"
      (formSubmitted)="createOrder($event)">
    </app-spare-part-contact-details-section>
  }
</div>
